import { Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { toolTipMap } from '../../../models/tool-tip-map.model';
import { StateService } from '../../../services/state.service';
import { TransformType } from '../../../models/enums.models';
import { LabelData } from '../../../models/label-data.model';

@Component({
    selector: 'app-control-base',
    standalone: true,
    imports: [],
    templateUrl: './control-base.component.html',
    styleUrl: './control-base.component.css'
})

export class ControlBaseComponent<T> implements ControlValueAccessor {
    @Input('label') _label: string = '';
    @Input('disabled') _disabled: boolean = false;
    @Input('required') _required: boolean = false;
    @Input('name') _name: string = '';
    @Input('maxLength') _maxLength?: number;
    @Input('minLength') _minLength?: number;
    @Input('placeHolder') _placeHolder: string = '';
    @Input('transform') _transform: TransformType = TransformType.None;
    @Input('errorText') _errorText: string = 'Unknown Error';
    @Input('isWhite') _white: boolean = false;
    @Input('isShort') _short: boolean = false;
    @Input('showInfo') _showInfo: boolean = false;
    @Input('toolTip') _toolTip = '';
    @Output('infoClicked') infoClicked: EventEmitter<void> = new EventEmitter();

    _value!: T;
    _showValidationError: boolean = false;
    _readOnly: boolean = false;
    _labelData: LabelData = new LabelData();

    constructor(@Optional() @Self() controlDir: NgControl, stateService: StateService) {
        controlDir.valueAccessor = this;

        stateService.$formDisabled.subscribe(value => {
            this._readOnly = value;
        });
    }

    _propagateChange = (_: any) => { };
    _propagateTouched = () => { };

    writeValue(value: any): void {
        this._value = value;
    }

    registerOnChange(fn: any): void {
        this._propagateChange = fn;
    }

    registerOnValidatorChange?(fn: () => void): void {
        this._propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._propagateTouched = fn;
    }

    setup() {
        this._labelData = {
            label: this._label,
            name: this._name,
            isWhite: this._white,
            isShort: this._short,
            required: this._required,
            info: '',
            showInfo: this.infoClicked.observed
        };

        for (const key of Object.keys(toolTipMap)) {
            if (key == this._name) {
                this._toolTip = toolTipMap[key];
            }
        }
    }

    markAsTouched(): void {
    }
}

